import { get } from '../axios'

export function get_users_group(map) {
  return get(`${process.env.VUE_APP_UMS}/ums-admin/group/list`, map)
}
